export const setCookie = (cookieName, cookieValue) => {
    var today = new Date()
    var expire = new Date()
    const nDays = 100

    expire.setTime(today.getTime() + 3600000 * 24 * nDays)
    document.cookie =
        cookieName +
        '=' +
        cookieValue +
        ';expires=' +
        expire.toGMTString() +
        ';domain=' +
        window.location.hostname +
        ';path=/'
}

export const readCookie = (name) => {
    var nameEQ = name + '='
    var ca = document.cookie.split(';')
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i]
        while (c.charAt(0) == ' ') c = c.substring(1, c.length)
        if (c.indexOf(nameEQ) == 0) {
            return c.substring(nameEQ.length, c.length)
        }
    }

    return null
}

export const deleteCookie = (cookieName) => {
    var today = new Date()
    var expire = new Date()
    const nDays = 100
    expire.setTime(today.getTime() - 3600000 * 24 * nDays)
    document.cookie =
        cookieName +
        '=' +
        ';expires=' +
        expire.toGMTString() +
        ';domain=' +
        window.location.hostname +
        ';path=/' +
        ';max-age=-1'
}
